<template>
  <div class="content">
    <h2 class="application-status">
      <span>Заявление в статусе</span>
      <span class="application-status__value" :class="applicationStatusClass">
        {{ applicationStatusText }}
      </span>
    </h2>

    <hr>
    <div class="content" v-if="store.application.status === 'enrolled'">
    <AspirantCongratulations v-if="store.isAspirant" />
    <FdoCongratulations v-else-if="store.application.enrolled_to == 'fdo'" />
    <StudentCongratulations v-else />
    <hr>

      <template v-if="hasEnrolmentData">
        <h3>Информация о зачислении</h3>

        <template v-if="hasEnrolments">
          <div class="enrolments">
            <div v-for="enrolment in enrolments" :key="enrolment.id || enrolment.group_number" class="enrolment-card">
              <div class="enrolment-card__group">Группа: <b>{{ enrolment.group_number }}</b></div>
              <div class="enrolment-card__block">
                <div class="enrolment-card__title">Факультет</div>
                <div>{{ enrolment.faculty_name }} ({{ enrolment.faculty_abbr }})</div>
              </div>
              <div class="enrolment-card__block">
                <div class="enrolment-card__title">Кафедра</div>
                <div>{{ enrolment.chair_name }} ({{ enrolment.chair_abbr }})</div>
              </div>
            </div>
          </div>
        </template>

        <template v-if="false">
          <div class="enrolments">
            <div class="enrolment-card">
              <div class="card card--banner-dark ">
                <img class="card__icon icon icon--dark" src="~images/info.svg" v-svg-inline/>
                <p>
                  Информация о&nbsp;зачислении в&nbsp;группу будет доступна после&nbsp;
                  <strong>25&nbsp;августа&nbsp;2026</strong>
                </p>
              </div>
            </div>
          </div>
        </template>

        <div class="join join--col join--sm enrolment-orders" v-if="hasEnrolmentOrders">
          <h4 class="enrolment-orders__title">Выписки из приказов</h4>
          <a
            v-for="enrolmentOrder in enrolmentOrders"
            :key="enrolmentOrder.id"
            href="#"
            :class="{ 'enrolment-order-card--loading': loadingOrderId === enrolmentOrder.id }"
            @click.prevent="downloadEnrolmentOrder(enrolmentOrder)"
            class="join__item card card--start enrolment-order-card"
          >
            <span class="enrolment-order-card__content">
              <span class="enrolment-order-card__title">Выписка из приказа №{{ enrolmentOrder.number }}</span>
              <small class="enrolment-order-card__direction">
                {{ enrolmentOrder.direction_code }} {{ enrolmentOrder.direction_name }}
                <span v-if="enrolmentOrder.magister_program">
                  ({{ enrolmentOrder.magister_program }})
                </span>
              </small>
            </span>
            <TLoader class="enrolment-order-card__loader" />
            <img class="enrolment-order-card__icon icon" src="@images/download.svg" v-svg-inline>
          </a>
        </div>

        <hr>
      </template>
    </div>

    <section class="application-contacts">
      <h5>Контакты</h5>

      <div class="application-contacts__grid" :class="{ 'application-contacts__grid--single': !manager }">
        <article class="application-contacts__card">
          <h4 class="application-contacts__title">Приёмная комиссия ТУСУРа</h4>

          <address class="application-contacts__items">
            <a class="application-contacts__item" href="tel:+73822900100">
              <img src="~/images/phone.svg" class="icon icon--primary icon--sm" v-svg-inline>
              <span>+7 (3822) 900-100</span>
            </a>
            <a class="application-contacts__item" href="mailto:postupi@tusur.ru">
              <img src="~/images/email.svg" class="icon icon--primary icon--sm" v-svg-inline>
              <span>postupi@tusur.ru</span>
            </a>
            <a
              class="application-contacts__max"
              href="https://max.ru/id7021000043_gos2"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src="~/images/max.svg" class="icon icon--sm" v-svg-inline>
              <span>канал в MAX</span>
            </a>

            <a
              class="application-contacts__max"
              href="https://max.ru/abiturient_tusur_bot"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src="~/images/max.svg" class="icon icon--sm" v-svg-inline>
              <span>чат в MAX</span>
            </a>
          </address>
        </article>

        <article v-if="manager" class="application-contacts__card manager-card">
          <div class="manager-card__aside">
            <img
              v-if="manager.photo?.path"
              class="manager-card__photo"
              :src="manager.photo.path"
              :alt="manager.full_name"
            >
            <img
              v-else
              class="manager-card__photo"
              src="~/images/avatar.svg"
              :alt="manager.full_name"
            >
          </div>

          <div class="manager-card__content">
            <a
              v-if="maxMessenger?.url"
              class="manager-card__max"
              :href="maxMessenger.url"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src="~/images/max.svg" class="icon icon--sm" v-svg-inline>
              <span>MAX</span>
            </a>
            <span v-else-if="maxMessenger" class="manager-card__max">
              <img src="~/images/max.svg" class="icon icon--sm" v-svg-inline>
              <span>MAX</span>
            </span>

            <h4 class="application-contacts__title">Ваш менеджер</h4>
            <p class="manager-card__name">{{ manager.full_name }}</p>

            <address class="application-contacts__items">
              <a v-if="manager.email" class="application-contacts__item" :href="`mailto:${manager.email}`">
                <img src="~/images/email.svg" class="icon icon--primary icon--sm" v-svg-inline>
                <span>{{ manager.email }}</span>
              </a>

              <a v-if="manager.work_phone" class="application-contacts__item" :href="phoneHref(manager.work_phone)">
                <img src="~/images/phone.svg" class="icon icon--primary icon--sm" v-svg-inline>
                <span>{{ manager.work_phone }}</span>
              </a>

              <a v-if="manager.multiline_phone" class="application-contacts__item" :href="phoneHref(manager.multiline_phone)">
                <img src="~/images/phone.svg" class="icon icon--primary icon--sm" v-svg-inline>
                <span>{{ manager.multiline_phone }}</span>
              </a>

              <span v-if="manager.extension" class="application-contacts__item">
                <span class="application-contacts__icon-spacer"></span>
                <span>доб. {{ manager.extension }}</span>
              </span>
            </address>
          </div>
        </article>
      </div>
    </section>
  </div>
</template>


<script setup>
import { computed, ref } from 'vue'
import { useApplicationStore } from '@widgets/application-profile'
import { TLoader } from '@shared/ui'
import AspirantCongratulations from './congratulations/AspirantCongratulations.vue'
import FdoCongratulations from './congratulations/FdoCongratulations.vue'
import StudentCongratulations from './congratulations/StudentCongratulations.vue'

const store = useApplicationStore()

const props = defineProps({
  readonly: { type: Boolean, default: false}
})
const manager = computed(() => {
  const applicationManager = store.application.manager
  return applicationManager && Object.keys(applicationManager).length > 0 ? applicationManager : null
})
const maxMessenger = computed(() => manager.value?.messengers?.find((messenger) => messenger.source === 'max') ?? null)

const enrolments = computed(() => store.application.enrolments ?? [])
const enrolmentOrders = computed(() => store.application.enrolment_orders ?? [])
const loadingOrderId = ref(null)
const hasEnrolments = computed(() => enrolments.value.length > 0)
const hasEnrolmentOrders = computed(() => enrolmentOrders.value.length > 0)
const hasEnrolmentData = computed(() => hasEnrolments.value || hasEnrolmentOrders.value)

const applicationStatusText = computed(() => {
  switch (store.application.status) {
    case 'accepted':
      return 'Принято'
    case 'participating':
      return 'Участвует в конкурсе'
    case 'withdrawn':
      return 'Отозвано'
    case 'not_passed':
      return 'Не прошел по конкурсу'
    case 'dismissed':
      return 'Отчислен'
    case 'enrolled':
      return 'Зачислен'
    default:
      return 'Статус неизвестен'
  }
})

const applicationStatusClass = computed(() => {
  switch (store.application.status) {
    case 'withdrawn':
    case 'not_passed':
    case 'dismissed':
      return 'application-status__value--danger'
    case 'enrolled':
      return 'application-status__value--success'
    default:
      return ''
  }
})

const phoneHref = (phone) => `tel:${phone.replace(/[^\d+]/g, '')}`

async function downloadEnrolmentOrder(enrolmentOrder) {
  if (loadingOrderId.value) return

  loadingOrderId.value = enrolmentOrder.id

  try {
    const role = props.readonly ? 'secretary' : 'abiturient'
    const data = await store.fetchEnrolmentOrderPdf(enrolmentOrder.id, role)
    if (!data) return

    const url = URL.createObjectURL(data)
    const link = document.createElement('a')

    link.href = url
    link.download = `Выписка из приказа о зачислении ${enrolmentOrder.number}.pdf`
    document.body.appendChild(link)
    link.click()
    link.remove()

    setTimeout(() => URL.revokeObjectURL(url), 1000)
  } finally {
    loadingOrderId.value = null
  }
}
</script>
